import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { useRootStore } from '../../../../../../providers/root-store-provider';
import { GainLossRowData, GainLossTableRenderer } from '../gain-loss-table-renderer';
import { AllocationsGainLossEnum } from '../../../../../../models/enums/allocations-gain-loss-enum';

export const RealizedCapitalTableContent: React.FC<{ type: AllocationsGainLossEnum }> = observer(({ type }) => {
    const { statisticStore, portfolioStore } = useRootStore();
    const { ratiosStore } = statisticStore;

    const gainLossData = useMemo((): GainLossRowData[] => {
        const isGain = type === AllocationsGainLossEnum.Gain;

        return ratiosStore.allRealizedAllocations
            .reduce<GainLossRowData[]>((acc, curr) => {
                if (curr.amount <= 0) {
                    return acc;
                }

                const profitValue = curr.profitValue - curr.feesValue;
                const isMatch = isGain ? profitValue > 0 : profitValue < 0;

                if (isMatch) {
                    const { invested } = curr;
                    const profitPercentage = invested > 0 ? (profitValue / invested) * 100 : 0;

                    acc.push({
                        ...curr,
                        profitValue,
                        profitPercentage,
                    });
                }
                return acc;
            }, [])
            .sort((a, b) => (isGain ? b.profitValue - a.profitValue : a.profitValue - b.profitValue))
            .slice(0, 5);
    }, [ratiosStore.allRealizedAllocations, type]);

    return (
        <GainLossTableRenderer
            loading={ratiosStore.loading}
            isRecalculating={portfolioStore.selectedPortfolio.isRecalculating}
            gainLossData={gainLossData}
        />
    );
});
